// extracted by mini-css-extract-plugin
export var askAiIcon = "_km-9";
export var container = "_km-0";
export var groupSeparator = "_km-a";
export var highlight = "_km-4";
export var resultIcon = "_km-5";
export var resultItem = "_km-7";
export var resultSubtitle = "_km-3";
export var resultTitle = "_km-2";
export var resultsList = "_km-1";
export var searchGroup = "_km-6";
export var selected = "_km-8";